import React from "react";
import { Box, Button, Typography } from "@mui/material";
import FormAutocompleteMulti from "app/components/form-components/FormAutocompleteMulti";
import { Add } from "@mui/icons-material";
function AddRequiredSkills({ control, preloadedData, setOpenSkillDialog, filterOptions, skills }) {
  return (
    <>
      <Box display={"flex"} gap={2} alignItems={"center"}>
        <h3>Skills Requirements</h3>
        <Button
          variant={"outlined"}
          endIcon={<Add />}
          size="small"
          onClick={() => setOpenSkillDialog(true)}
          style={{ paddingY: 0, maxHeight: "30px" }}
        >
          <Typography variant="body2">Add Skill</Typography>
        </Button>
      </Box>
      <FormAutocompleteMulti
        name="jp_required_skills"
        control={control}
        label={"Required Skills *"}
        defaultValue={preloadedData ? preloadedData.jp_required_skills : null}
        isOptionEqualToValue={(option, value) => {
          return option.jp_id === value.jp_id;
        }}
        filterOptions={filterOptions}
        values={
          skills
            ? skills.map((skill) => ({ jp_id: skill.jp_id, label: skill.jp_skill }))
            : [{ jp_id: 0, label: "Loading..." }]
        }
        helperText={"Skills is required"}
      />
    </>
  );
}

export default AddRequiredSkills;
